PJQ.views.rfq.RFQEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BUDGET, 'modal-rfq-edit'),
        width: '95%',
        maxWidth: 1500,
        model: null,
        isShowCloseButton: true,
        onSave: _.noop(),
        onDelete: _.noop()
    },
    events: {
        'click .btn-view-change-request': 'viewChangeRequest',
        'click .btn-close': 'close',
        'click .btn-save': 'saveRFQ',
        'click .btn-delete': 'deleteRFQ',
        'click .btn-send-request': 'sendRequest',
        'click .btn-update-response': 'updateResponseClicked',
        'click .impact-response>button': 'impactResponseChanged'
    },
    beforeModalCreated: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        if (this.options.changeRequest == null) {
            this.options.changeRequest = new PJQ.models.changeRequests.ChangeRequest({
                id: this.model.get('changeRequestId')
            });
        }

        if (this.model == null) {
            if (!this.options.changeRequest.isFetched) {
                await this.options.changeRequest.fetch();
            }

            this.model = new PJQ.models.rfq.RFQ({
                title: "",
                description: this.options.changeRequest.get('description'),
                changeRequestId: this.options.changeRequest.id,
                changeRequestNumber: this.options.changeRequest.get('number'),
                projectId: this.options.changeRequest.get('projectId'),
                statusId: PJQ.constants.rfq.rfqStatus.DRAFT,
                amount: 0
            });
        }

        if (!this.model.isNew()) {
            await this.model.fetch();
        }

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched) {
            return;
        }

        let pContactId = this.options.project.permissions?.get('contactId');
        this.options.isAssignee = pContactId > 0 && (this.model.contractedContact?.id === pContactId || this.model.assignees.get(this.options.project.get('contactId')));
        this.options.canAdd = this.options.project.hasPermission('changeRequests.canAdd');
        this.options.isAdmin = this.options.project.hasPermission('changeRequests.isAdmin');
        this.options.canViewChangeRequests = this.options.isAdmin;
        this.options.canEdit = this.options.isAdmin && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.APPROVED && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.CLOSED;
        this.options.canRespond = (this.options.isAdmin || this.options.isAssignee) && (this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.PRICING || this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.REVISE);
        this.options.canDelete = this.options.isAdmin && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.APPROVED;
        this.options.canEditStatus = this.options.isAdmin && !this.model.isNew();
        this.options.canSendRequest = this.options.isAdmin && !this.model.isNew() && (this.options.canEdit || this.options.canRespond) && (this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.DRAFT || this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.PRICING || this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.REVISE);

        if (!this.isFetched || this.model.isNew()) {
            return;
        }

        let status = this.model.get('statusId');
        if (status === PJQ.constants.rfq.rfqStatus.APPROVED
            || status === PJQ.constants.rfq.rfqStatus.VOID) {
            this.options.canEdit = false;
            this.options.canDelete = false;
        } else if (status == PJQ.constants.rfq.rfqStatus.PRICING
            || status == PJQ.constants.rfq.rfqStatus.REVISE) {
            this.options.canEdit = false;
        }
    },
    renderData: function () {
        return {
            model: this.model,
            isAssignee: this.options.isAssignee,
            canAdd: this.options.canAdd,
            canEdit: this.options.canEdit,
            canDelete: this.options.canDelete,
            isAdmin: this.options.isAdmin,
            canRespond: this.options.canRespond,
            canViewChangeRequests: this.options.canViewChangeRequests,
            isFetched: this.isFetched,
            activeView: this.options.activeView,
            canSendRequest: this.options.canSendRequest,
            views: this.views
        }
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        this.renderGeneral();
        this.renderResponse();
    },
    renderGeneral: function () {
        new PJQ.Binder(this.$el, this.model, {
            useDecimalPercentFields: true,
            watchElements: [
                'input',
                'textarea'
            ]
        });

        PJQ.helpers.inputHelpers.inputMaskCurrency(this.$('.input-dollars-full'), 2, true);

        let choices = _.map(PJQ.constants.rfq.rfqStatus, (st) => {
            return {
                id: st,
                name: PJQ.constants.rfq.rfqStatusNames[st],
                disabled: false
            }
        });
        this.statusPicker = new PJQ.inputs.Selectpicker({
            el: this.$('.select-status'),
            choices: choices,
            isIntChoices: true,
            defaultValue: this.model.get('statusId'),
            canEdit: this.options.canEditStatus,
            onChange: (value) => {
                let newStatus = value,
                    fnSave = () => {
                        this.model.set('statusId', newStatus);
                        if (!this.model.isNew()) {
                            this.model.save(null, {
                                success: _.bind(function () {
                                    this.model.dirtyAttributes = {};
                                    if (typeof this.options.onSave === 'function')
                                        this.options.onSave(this.model, false);
                                    this.render();
                                    PJQ.notifications.notify.successNotify({
                                        message: 'RFQ saved successfully'
                                    });

                                    if (newStatus === PJQ.constants.rfq.rfqStatus.PRICING || newStatus === PJQ.constants.rfq.rfqStatus.REVISE) {
                                        this.sendRequest();
                                    }
                                }, this)
                            })
                        }
                    };

                if (newStatus === PJQ.constants.rfq.rfqStatus.APPROVED && this.model.get('hasCostImpact')) {
                    let oldStatus = this.model.get('statusId');

                    new PJQ.views.modals.YesNo({
                        header: "Approve RFQ?",
                        body: "Approving this RFQ will apply the quote amount to it's related change request item revenue and cost. Would you like to continue?",
                        onYes: () => {
                            fnSave();
                        },
                        onNo: () => {
                            this.model.set('statusId', oldStatus);
                            this.render();
                        }
                    });
                    return;
                }

                fnSave();
            }
        });

        this.companyPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.contracted-contact'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            hideUsers: true,
            selectedContact: this.model.contractedContact,
            isSingleChoice: true,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.model.isNew() || this.model.contractedContact == null,
            onChange: (selectedContact) => {
                this.model.contractedContact = selectedContact;
                this.model.set('contractedContactId', selectedContact?.id);

                this.render();
            }
        });

        this.assigneePicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.assigned-to'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            hideUsers: true,
            selectedContact: this.model.assignees.models,
            isSingleChoice: false,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEdit && this.options.isAdmin,
            onChange: (selectedContacts) => {
                this.model.assignees.reset(selectedContacts);
                this.model.set('assigneeIds', _.pluck(selectedContacts || [], 'id'));
            }
        });

        this.distributeToPicker = new PJQ.views.contacts.ContactsSelectInput({
            el: this.$('.distribute-to'),
            context: PJQ.constants.contacts.contexts.PROJECTCONTACTS,
            hideUsers: true,
            selectedContact: this.model.distributeTo.models,
            isSingleChoice: false,
            canViewContacts: this.options.project.hasPermission('projectContacts.canView'),
            canEdit: this.options.canEdit && this.options.isAdmin,
            onChange: (selectedContacts) => {
                this.model.distributeTo.reset(selectedContacts);
                this.model.set('distributeToIds', _.pluck(selectedContacts || [], 'id'));
            }
        });

        new PJQ.inputs.Datepicker({
            el: this.$('.due-date'),
            canEdit: this.options.canEdit,
            datepickerOptions: {
                format: PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE,
                defaultDate: this.model.get('dueDate') != null ? PJQ.helpers.dateHelpers.parseDateString(this.model.get('dueDate'), false) : null
            },
            onChange: _.bind(function (newDate) {
                this.model.set('dueDate', newDate);
            }, this)
        });

        if (_.size(this.model.dirtyAttributes) === 1 && this.model.dirtyAttributes.hasOwnProperty('dueDate')) {
            this.model.dirtyAttributes = {};
            this.model.isDirty = false;
        }

        this.fileUploader = new PJQ.views.files.FileUploaderGrid({
            el: this.$('.rfq-file-uploader'),
            collection: this.model.attachments,
            canUpload: this.options.isAdmin && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.APPROVED && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.CLOSED,
            useApiV2: true,
            canDelete: this.options.isAdmin && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.APPROVED && this.model.get('statusId') !== PJQ.constants.rfq.rfqStatus.CLOSED,
            previewImageDimension: 150,
            onSuccess: _.bind(function (file) {
                this.model.isDirty = true;
            }, this),
            onDelete: _.bind(function (attachment, callback) {
                if (attachment.get('id') > 0) {
                    attachment.set('delete', true);
                } else {
                    attachment.destroy();
                }

                this.model.isDirty = true;
                callback();
            }, this)
        });
    },
    renderResponse: function () {
        if (!this.model.get('hasCostImpact')) {
            return;
        }

        if (_.size(this.model.responseAttachments.models) > 0) {
            new PJQ.views.files.FileUploaderGrid({
                el: this.$('.rfq-response-file-uploader'),
                collection: this.model.responseAttachments,
                canUpload: false,
                useApiV2: true,
                canDelete: false
            });
        }
    },
    updateResponseClicked: function () {
        this.updateResponse();
    },
    updateResponse: function (hasCostImpact = null) {
        new PJQ.views.rfq.RFQResponseModal({
            model: this.model,
            hasCostImpact: hasCostImpact,
            onSubmit: (data) => {
                this.model.set(data.response);
                this.model.responseAttachments = data.attachments;
                this.submitResponse(() => {
                    this.render();
                });
            }
        });
    },
    impactResponseChanged: function (e) {
        let hasCostImpact = $(e.currentTarget).data('value');
        if (!hasCostImpact) {
            new PJQ.views.modals.YesNo({
                header: "Submit Response?",
                body: "Are you sure you want to submit the response of <strong>no impact</strong> for this RFQ?",
                onYes: () => {
                    this.model.set('hasCostImpact', hasCostImpact);
                    this.submitResponse(() => {
                        this.render();
                    });
                }
            });
            return;
        }

        this.updateResponse(hasCostImpact);
    },
    submitResponse: function (callback) {
        let loader = new PJQ.Loader(this.$('.modal-content'));
        this.model.respond((result) => {
            loader.remove();
            if (result) {
                PJQ.notifications.notify.successNotify({
                    message: 'RFQ response submitted'
                });

                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.app.session.project.trigger('rfqChanged', this.model);

                this.render();

                if (typeof callback === 'function') {
                    callback();
                }
            }
        });
    },
    sendRequest: function () {
        let message = "Would you like to send this RFQ to the assigned contact?";
        if (this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.DRAFT) {
            message += ' This will also set the status to ' + PJQ.constants.rfq.rfqStatusNames[PJQ.constants.rfq.rfqStatus.PRICING] + '.';
        }

        new PJQ.views.modals.YesNo({
            header: "Send Request?",
            body: message,
            onYes: () => {
                this.model.sendQuoteRequest((success) => {
                    if (success) {
                        PJQ.notifications.notify.successNotify({
                            message: 'RFQ sent successfully'
                        });
                        this.model.set('requestLastSentOn', new Date());
                        this.render();
                    } else {
                        PJQ.notifications.notify.errorNotify({
                            message: 'Failed to send RFQ'
                        });
                    }
                });
            }
        });
    },
    viewChangeRequest: function () {
        this.removeModal();
        new PJQ.views.changeRequests.ChangeRequestEditModal({
            model: this.options.changeRequest
        });
    },
    saveRFQ: function () {
        let isNew = this.model.isNew(),
            quoteAmount = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-quote-amount'));
        this.model.set('amount', quoteAmount != null ? quoteAmount : 0);
        this.save(() => {
            PJQ.notifications.notify.successNotify({
                message: 'RFQ saved successfully'
            });

            if (!isNew) {
                this.removeModal();
            }
        });
    },
    validate: function () {
        let isValid = true;

        if (!this.assigneePicker.validate()) {
            isValid = false;
        }

        if (this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.PRICING || this.model.get('statusId') === PJQ.constants.rfq.rfqStatus.REVISE) {
            let quoteAmount = PJQ.helpers.inputHelpers.getMoneyInputValue(this.$('.input-quote-amount'));
            if (quoteAmount == null || quoteAmount.trim() === '') {
                isValid = false;
                PJQ.helpers.inputHelpers.setInputError(this.$('.input-quote-amount'), false);
            }
        }

        return isValid;
    },
    save: function (callback) {
        if (!this.validate())
            return;

        this.model.save(null, {
            success: _.bind(function () {
                this.render();
                if (typeof this.options.onSave === 'function') {
                    this.options.onSave(this.model);
                }

                PJQ.app.session.project.trigger('rfqChanged', this.model);
                if (typeof callback === 'function') {
                    callback(true);
                }
            }, this)
        });
    },
    deleteRFQ: function () {
        let rfqId = this.model.id
        new PJQ.views.modals.DeleteCancel({
            header: "Confirm Delete",
            body: "Are you sure you want to delete this RFQ?",
            onDelete: _.bind(function () {
                this.model.destroy({
                    success: _.bind(function () {
                        PJQ.notifications.notify.successNotify({
                            message: 'RFQ deleted successfully'
                        });

                        if (typeof this.options.onDelete === 'function')
                            this.options.onDelete(rfqId);

                        this.removeModal();
                    }, this)
                });
            }, this)
        });
    },
    close: function () {
        if (this.model.hasChanged() && this.options.canEdit) {
            new PJQ.views.modals.SaveDontSave({
                header: "Unsaved Changes",
                body: "Do you want to save changes?",
                onSave: _.bind(function () {
                    this.saveRFQ();
                    this.removeModal();
                }, this),
                onDontSave: _.bind(function () {
                    this.removeModal();
                }, this)
            });
        } else {
            this.removeModal();
        }
    }
});